// Mark + wordmark bZapper. O SVG é servido na raiz (sync-brand copia de @bzapper/brand).
export function Logo({ height = 28 }: { height?: number }) {
  return (
    <span className="flex items-center gap-2">
      <img src="/logo/svg/bzapper-mark-amber.svg" alt="" width={height} height={height} aria-hidden />
      <span className="text-lg font-bold tracking-tight" style={{ fontFamily: 'Sora, system-ui, sans-serif' }}>
        bZapper
      </span>
    </span>
  );
}
